import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

type SupportedLanguage = 'en' | 'sv';

@Injectable()
export class TranslationService {
    private translations: Record<string, string> = {};
    public language: SupportedLanguage = 'en';

    constructor(private http: HttpClient) {
    }

    async load() {
        this.language = this.detectBrowserLanguage();

        try {
            this.translations = await this.http
                .get<Record<string, string>>(`/api/translations/${this.language}`)
                .toPromise() || {};
        }
        catch (error) {
            console.log(`Could not load ${this.language} translations`, error);
            this.language = 'en';
            this.translations = {};
        }
    }

    translate(key: string) {
        return this.translations[key] || key;
    }

    private detectBrowserLanguage(): SupportedLanguage {
        let languages = typeof navigator !== 'undefined'
            ? [navigator.language, ...(navigator.languages || [])]
            : [];

        return this.normalizeLanguage(languages[0]);
    }

    private normalizeLanguage(language?: string): SupportedLanguage {
        return language && language.toLowerCase().startsWith('sv') ? 'sv' : 'en';
    }
}
